$().ready(function() {
  // Startup the application!
  weaved.startup()
})
